
/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
Logo
********************************************************************************************

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       22nd December 2020

*******************************************************************************************/
import React            from 'react';
import { Box }          from '@mui/system';  
import { HomeLocation } from 'router/locations';
import Logo             from './Logo';

/**
 * A logo monogram component that renders the logo inside a styled container.
 * It allows customization of the destination (`to`) and theme (`dark`) properties, as well as any other props passed to the Logo component.
 * 
 * @component
 * @example
 * // Using the default logo and destination
 * <LogoMonogram dark={false} />
 * 
 * @param {string} [to=HomeLocation.path] - The destination URL to navigate to when the logo is clicked. Default is `HomeLocation.path`.
 * @param {boolean} [dark=true] - Determines whether the logo should use the dark theme. Default is `true`.
 * @param {object} [props] - Additional props to pass to the `Logo` component and the outer `Box` container, such as styling and event handlers.
 * 
 * @returns {JSX.Element} The rendered logo monogram component.
 */
export const LogoMonogram = ({to = HomeLocation.path, dark = true, ...props}) => (    
    <Box sx={{maxWidth:150, margin:'auto', ...props.sx}}>
        <Logo to={to} dark={dark} {...props}/>
    </Box>
);

export default LogoMonogram;